import React from 'react';
import { PendingIndicatorIcon } from '../../../../../core/themes/icons/PendingIndicator';

const NodeRenderer = ({
  node,
  classes,
  handleSelect,
  handleDoubleClick,
  stepReadOnly
}) => {
  let content, id;
  const isPending = node.fundNode && node.status === 'PENDING';

  if (node.fundFamilyNode) {
    content = node.fundFamilyName;
    id = node.fundFamilyId;
  } else {
    content = node.fundName;
    id = node.fundId;
  }

  return (
    <div
      className={classes.itemLabelText}
      onDoubleClick={() => {
        if (!stepReadOnly) {
          handleSelect(node.nodeId);
          handleDoubleClick();
        }
      }}
    >
      {isPending && (
        <PendingIndicatorIcon
          title="Pending Fund"
          style={{
            marginTop: '15px',
            marginLeft: '-15px',
            position: 'absolute'
          }}
        />
      )}
      <span>{content}</span>
      <div className={classes.itemId}>
        <span>(ID {id})</span>
        {node.fundNode &&
          Object.values(node.fundTags).map(tag => (
            <span className={classes.tag} key={tag.nodeId}>
              {tag}
            </span>
          ))}
        {node.fundInvestorTagNode && (
          <span className={classes.tag}>{node.name}</span>
        )}
      </div>
    </div>
  );
};

export default NodeRenderer;
